import { render, staticRenderFns } from "./RecommendStudentInfo.vue?vue&type=template&id=7384d9ca&scoped=true&"
import script from "./RecommendStudentInfo.vue?vue&type=script&lang=js&"
export * from "./RecommendStudentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7384d9ca",
  null
  
)

export default component.exports